var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-panel',{staticClass:"filter-panel",attrs:{"apply-filter-immediately":false,"filter-parameters":_vm.formattedFilters,"notification-text":null,"api-request-data":_vm.apiRequestData},on:{"update":_vm.applyFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }